"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ICON_BUTTON_SIZES = void 0;
var _T_SHIRT_SIZES = require("./T_SHIRT_SIZES");
var ICON_BUTTON_SIZES = Object.freeze({
  xs: _T_SHIRT_SIZES.T_SHIRT_SIZES.xs,
  sm: _T_SHIRT_SIZES.T_SHIRT_SIZES.sm,
  md: _T_SHIRT_SIZES.T_SHIRT_SIZES.md,
  lg: _T_SHIRT_SIZES.T_SHIRT_SIZES.lg
});
exports.ICON_BUTTON_SIZES = ICON_BUTTON_SIZES;